import { createUseStyles } from 'react-jss';

import { ThemeProps } from '@styles/theme';
import { textOverflowDots } from '@resources/mixins';

export const useStyles = createUseStyles((theme: ThemeProps) => ({
    mainWrapper: {
        width: '20%',
        height: '100%',
        backgroundColor: theme.colors.grey_background,
        boxShadow: '4px 0 12px 0 rgba(115, 115, 115, 0.12)',
    },

    graphContainer: {
        flex: '1 1 0',
        minHeight: 0,
        // maxHeight: 'calc(100vh - 320px)',
        width: '100%',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: theme.colors.grey_darker,
        backgroundColor: theme.colors.white,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
    },

    headerWraper: {
        width: '100%',
        height: '50px',
        display: 'flex',
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'space-between',
        padding: 15,
        [theme.down('mobile')]: {
            height: 'auto',
            flexWrap: 'wrap',
            gap: theme.spacing(2),
            padding: theme.spacing(2.5),
        },
        fontFamily: theme.font.primary,
        fontSize: theme.spacing(5),
        color: theme.colors.text_heading,
        borderBottomWidth: 1,
        borderStyle: 'solid',
        borderColor: theme.colors.grey_darker,
    },

    headerControls: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        [theme.down('mobile')]: {
            flexWrap: 'wrap',
            rowGap: theme.spacing(1.5),
        },
    },

    zoomControls: {
        display: 'flex',
        alignItems: 'center',
        gap: 2,
    },

    zoomSliderWrap: {
        width: 110,
        flexShrink: 0,
        margin: '0 8px',
    },

    zoomReadout: {
        fontSize: 11,
        color: theme.colors.grey_darker,
        minWidth: 30,
        textAlign: 'right',
        fontFamily: 'monospace',
        whiteSpace: 'nowrap',
    },

    noEvent:{
        alignContent: 'center',
        textAlign: 'center',
        minHeight: 'calc(100dvh - 320px)',
        fallbacks: { minHeight: 'calc(100vh - 320px)' },
        width: '100%',
        fontFamily: theme.font.secondary,
        fontStyle: 'italic',
        fontSize: 20,
    },

    chartContentContainer: {
        height: "100%",
        overflowX: "auto",
        overflowY: "hidden",
        WebkitOverflowScrolling: 'touch',
        overscrollBehaviorX: 'contain',
    },

    chartViewport: {
        position: 'relative',
        height: '100%',
        overflow: 'visible',
    },

    selectedTooltip: {
        position: 'absolute',
        zIndex: 3,
        pointerEvents: 'auto',
    },

    stepGroupPopover: {
        position: 'absolute',
        zIndex: 4,
        pointerEvents: 'auto',
        minWidth: 280,
        maxWidth: 380,
        maxHeight: 240,
        overflowY: 'auto',
        padding: '4px 0',
        backgroundColor: theme.colors.surface_elevated,
        border: `1px solid ${theme.colors.grey_darker}`,
        borderRadius: 8,
        boxShadow: '0 6px 20px 0 rgba(17, 7, 41, 0.18)',
        fontFamily: theme.font.primary,
        fontSize: 13,
    },

    stepGroupTitle: {
        padding: '6px 12px',
        fontWeight: 700,
        color: theme.colors.text_heading,
        borderBottom: `1px solid ${theme.colors.grey_light}`,
    },

    stepGroupRow: {
        display: 'flex',
        alignItems: 'baseline',
        gap: 10,
        padding: '6px 12px',
        cursor: 'default',
        '&:hover': {
            backgroundColor: theme.colors.transp_violet,
        },
    },

    stepGroupIdx: {
        flexShrink: 0,
        minWidth: 34,
        fontWeight: 700,
        color: theme.colors.violet_primary,
    },

    stepGroupName: {
        flex: 1,
        color: theme.colors.text_heading,
        ...textOverflowDots,
    },

    stepGroupTime: {
        flexShrink: 0,
        fontSize: 12,
        fontFamily: 'monospace',
        color: theme.colors.grey_darker,
        whiteSpace: 'nowrap',
    },

    loader: {
        color: theme.colors.violet_primary,
    },
}));